module.exports = __webpack_public_path__ + "../resources/images/illustration_sent-38bf5642768361f85831e4a83fc642e7.svg";